import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getCodigosOrcamentarios({ commit }) {
      try {
        const response = await api.get('/codigos-orcamentarios')

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
